import { ViewController } from 'elc-service';
import {
    ProductEngravingTriggeredUseCase,
    IEngravingData
} from '../use-cases/ProductEngravingTriggeredUseCase';

export class ProductEngravingViewController extends ViewController {
    public openEngraving = (engravingData: IEngravingData) => {
        const productEngravingTriggeredUseCase = new ProductEngravingTriggeredUseCase(
            engravingData
        );

        productEngravingTriggeredUseCase.execute();
    };
}
